
export default {
  props: {
    icon: {type: String, required: true},
    small: {type: Boolean, default: false},
    width: {type: String, default: '2rem'},
    height: {type: String, default: '2rem'}
  }
}
